import React, { Component } from "react";

import {
  Wrapper,
  Row,
  Card,
  Copy,
  Bold,
  Button,
  Icon
} from "app/NativeComponents/common";
import EmailAddressMore from "./EmailAddressMore";
class EmailAddressItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show_options: false
    };
    this.toggleOptions = this.toggleOptions.bind(this);
  }

  toggleOptions(show_options = false) {
    this.setState({
      show_options
    });
  }

  renderSource(email_address) {
    const { colors } = this.props;

    let source = "";
    if (email_address.manual == 1) {
      source = "Source: Manually Added";
    } else {
      source = "Source: Skip Trace";
    }

    return (
      <Copy style={{ fontSize: 12, color: colors.light_text_color }}>
        {source}
      </Copy>
    );
  }

  renderOptionsButton() {
    return (
      <Wrapper
        style={{
          padding: 15,
          paddingLeft: 0,
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <Button
          tooltip={"More Options"}
          onPress={() => {
            this.toggleOptions(true);
          }}
          style={{
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Icon icon={"more-vert"} />
        </Button>
      </Wrapper>
    );
  }

  renderDeliverableUndeliverable(phone_number) {
    const { colors } = this.props;
    if (phone_number.valid_email_status) {
      let deliverable_title = "Deliverable";
      let deliverable_copy = "This email address is verified and deliverable.";
      let deliverable_icon_color = colors.success_color;
      let deliverable_icon = "check-circle";

      switch (phone_number.valid_email_status) {
        default:
        case "deliverable":
          deliverable_title = "Deliverable";
          deliverable_copy = "This email address is verified and deliverable.";
          deliverable_icon_color = colors.success_color;
          deliverable_icon = "check-circle";
          break;

        case "undeliverable":
          deliverable_title = "Undeliverable";
          deliverable_copy = "This email address undeliverable.";
          deliverable_icon_color = colors.error_color;
          deliverable_icon = "cancel";
          break;

        case "risky":
          deliverable_title = "Risky";
          deliverable_copy =
            "This and email sent to this address may not be delivered.";
          deliverable_icon_color = colors.yellow_card_color;
          deliverable_icon = "warning";
          break;
        case "unknown":
          deliverable_title = "Unknown";
          deliverable_copy =
            "This and email sent to this address may or may not be delivered.";
          deliverable_icon_color = colors.yellow_card_color;
          deliverable_icon = "warning";
          break;
      }

      return (
        <Wrapper style={{ marginLeft: 10 }} tooltip={deliverable_copy}>
          <Row>
            <Icon
              icon={deliverable_icon}
              size={14}
              color={deliverable_icon_color}
            />
            <Copy
              style={{
                textColor: colors.light_text_color,
                fontSize: 12,
                marginLeft: 2,
                marginRight: 5
              }}
            >
              {deliverable_title}
            </Copy>
          </Row>
        </Wrapper>
      );
    }
  }

  render() {
    const { email_address } = this.props;
    return (
      <Card style={{ marginBottom: 0 }}>
        <Wrapper>
          <Row>
            <Wrapper style={{ padding: 15, flex: 1 }}>
              <Row>
                <Copy>
                  <Bold>{email_address.email_address}</Bold>
                </Copy>
                {this.renderDeliverableUndeliverable(email_address)}
              </Row>

              {!!email_address.email_label ? (
                <Copy>{email_address.email_label}</Copy>
              ) : null}
              {this.renderSource(email_address)}
            </Wrapper>
            {this.renderOptionsButton(email_address)}
          </Row>
        </Wrapper>
        <EmailAddressMore
          {...this.props}
          email_address={email_address}
          show_options={this.state.show_options}
          toggleOptions={this.toggleOptions}
        />
      </Card>
    );
  }
}

export default EmailAddressItem;
